import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import * as AWS from 'aws-sdk';
import awsmobile from './aws-exports';

const containerElementName = 'faceLivenessReactContainer';

@Component({
    selector: 'app-faceliveness-react-wrapper',
    template: `<span #${containerElementName}></span>`,
    // styleUrls: [''],
    encapsulation: ViewEncapsulation.None,
})
export class FaceLivenessReactWrapperComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
    @ViewChild(containerElementName, { static: true }) containerRef!: ElementRef;

    @Input() public counter = 10;
    @Input() public sessionId = null;
    @Output() public livenessResults = new EventEmitter<any>();
    @Output() public livenessErrors = new EventEmitter<any>();
    region = awsmobile['aws_project_region']

    constructor() {
    }

    ngOnInit(): void {
        console.log('Component Loaded' + this.sessionId)
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.render();
    }

    ngAfterViewInit() {
        this.render();
    }

    ngOnDestroy() {
        ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
    }

    handleAnalysisComplete = async () => {
        var rekognition = new AWS.Rekognition();
        var params = {
            SessionId: this.sessionId
        };
        rekognition.getFaceLivenessSessionResults(params).promise().then(data => {
            this.livenessResults.emit(data);
            console.log(data);
        }).catch(err => {
            console.log(err);
        });
    }

    handleError = async (err: any) => {
        this.livenessErrors.emit(err);
    }


    private render() {

        const dictionary = {
            // use default strings for english
            en: null,
            pt: {
              instructionsHeaderHeadingText: 'Prova de Vida',
              instructionsHeaderBodyText: 'Você irá realizar um processo de verificação facial para provar que é uma pessoa real',
              photosensitivyWarningHeadingText: 'Advertência de fotosensibilidade',
              photosensitivyWarningBodyText:
                'Esta verificação mostra luzes coloridas. Tenha cuidado se for fotosenssível.',
              goodFitCaptionText: 'Bom ajuste',
              tooFarCaptionText: 'Muito longe',
              instructionsBeginCheckText: 'Começar a verificar',
              instructionListHeadingText: 'Siga as instruções para completar a verificação',
              instructionListStepOneText: 'Quando aparecer um oval, preencha o oval com sua face.',
              instructionListStepTwoText: 'Maximize o brilho da sua tela.',
              instructionListStepThreeText: 'Não utilize óculos escuros ou máscara.',
              instructionListStepFourText: 'Utilize um local iluminado que não tenha luz direta do Sol.',
              hintCenterFaceText: 'Centralize o rosto',
              hintCenterFaceInstructionText:
                'Instruction: Before starting the check, make sure your camera is at the center top of your screen and center your face to the camera. When the check starts an oval will show up in the center. You will be prompted to move forward into the oval and then prompted to hold still. After holding still for a few seconds, you should hear check complete.',
              hintFaceOffCenterText:
                'Face is not in the oval, center your face to the camera.',
              hintMoveFaceFrontOfCameraText: 'Mova sua face para o centro da câmera',
              hintTooManyFacesText: 'Ensure only one face is in front of camera',
              hintFaceDetectedText: 'Face detected',
              hintCanNotIdentifyText: 'Move face in front of camera',
              hintTooCloseText: 'Mova para trás',
              hintTooFarText: 'Mova para mais perto',
              hintConnectingText: 'Conectando...',
              hintVerifyingText: 'Verificando...',
              hintCheckCompleteText: 'Checagem completa',
              hintIlluminationTooBrightText: 'Mova para uma área menos iluminada',
              hintIlluminationTooDarkText: 'Mova para uma área mais iluminada',
              hintIlluminationNormalText: 'Lighting conditions normal',
              hintHoldFaceForFreshnessText: 'Mantenha-se imóvel',
              hintMatchIndicatorText: '50% completado. Siga aproximando-se.',
              hintHoldFacePositionCountdownText: 'Mantenha a posição durante a contagem regressiva',
            },
          };

        const language="pt"

        const { counter } = this;

        ReactDOM.render(
            <React.StrictMode>
                <div>
                    <FaceLivenessDetector sessionId={this.sessionId} region={this.region} onAnalysisComplete={this.handleAnalysisComplete} 
                    onError={this.handleError}
                    displayText={dictionary[language]}
                    />
                </div>
            </React.StrictMode>
            , this.containerRef.nativeElement);
    }
}
